import src from "IMAGE";
export default { src, width: 1786, height: 179, blurWidth: 0, blurHeight: 0};
